import '../styles/global.scss'
import '../styles/reset.scss'
import '../components/header/headerAppyShop.scss'
import '../components/footer/footerAppyShop.scss'
import { appWithTranslation } from 'next-i18next'
import nextI18NextConfig from '../next-i18next.config.js'
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from '../store/configureStore'
import { ToastContainer } from 'react-toastify'
import SessionGuard from '../components/customer/sessionGuard'
import { isJwtValid } from '../services/customer-services'
import { logout } from '../store/action'


// persisted customer with an expired JWT: logout before the first render
const logoutIfJwtExpired = () => {
    const customer = store.getState().customer;
    if (customer !== undefined && customer !== null && !isJwtValid(customer.jwt)) {
        store.dispatch(logout());
    }
}

const MyApp = ({ Component, pageProps }) => {
    return process.browser ? (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor} onBeforeLift={logoutIfJwtExpired}>
                <ToastContainer />
                <SessionGuard />
                <Component {...pageProps} />
            </PersistGate>
        </Provider>
    ) : (
        <Provider store={store}>
            <ToastContainer />
            <Component {...pageProps} />
        </Provider>
    )
}



export default appWithTranslation(MyApp, nextI18NextConfig)